import "./cards.css"
import ReactCardFlip from "react-card-flip"
import React, { Component } from "react"
class RecommendationCloneCard extends Component{
    constructor(props){
        super(props)
        this.state = (() => {
            var data = props.data
            return {
                name: data.name,//recommendation.company.length > 16 && window.innerWidth > 576? recommendation.company.substring(0, 16) + "..." : recommendation.company,
                pricepercent: 100,//(recommendation.targetdifference * 100 / pointedprice).toFixed(2),//((props.indicatedprice / props.pointedprice) * 100).toFixed(2),
                indicatedprice: data.haschange? data.change: 0,//recommendation.targetdifference,//props.indicatedprice > 0? <font color="#4CAF50">{"+" + props.indicatedprice + "(" + pricepercent + "%)"}</font>:<font color="#F44336">{props.indicatedprice + "(" + pricepercent + "%)"}</font>,
                pointedprice: data.pointedprice,//parseFloat(pointedprice).toFixed(2),
                haschange: data.haschange,
                hasopenclose: data.hasopenclose,
                showinr: data.showinr,//parseFloat(dailyhistory[0]["open"]).toFixed(2),//props.openedat,
                openedat: data.hasopenclose?data.openedat:0,//parseFloat(dailyhistory[0]["open"]).toFixed(2),//props.openedat,
                closedat: data.hasopenclose?data.closedat:0,//parseFloat(dailyhistory[0]["close"]).toFixed(2),//props.closedat,
                high: 100,//parseFloat(dailyhistory[0]["high"]).toFixed(2),//props.closedat,
                low: 100,//parseFloat(dailyhistory[0]["low"]).toFixed(2),//props.closedat,
                volume: 100,//dailyhistory[0]["volume"],//props.closedat,
                hasfrontdescription:data.hasfrontdescription,
                hasbackdescription:data.hasbackdescription,
                frontdescription:data.hasfrontdescription?data.frontdescription:"",
                frontdescriptionheader:data.hasfrontdescription?data.frontdescriptionheader:"",
                frontdescriptionheadercolor:data.hasfrontdescription?data.frontdescriptionheadercolor:"",
                backdescription:data.hasbackdescription?data.backdescription:""
            }
        })()
    }
    
    flipThisCard(flip){
        const newstate = {...this.state}
        newstate.isFlipped = flip
        this.setState(newstate)
    }
    render(){
        return <div onMouseLeave={this.flipThisCard.bind(this, false)} className="c_recommendation_card">
            <ReactCardFlip isFlipped={this.state.isFlipped}>
                <div className="c_card_front" onMouseEnter={this.flipThisCard.bind(this, true)}>
                    <table>
                        <tbody>
                            <tr>
                                <th><img alt="Logo"className="c_recommendation_logo"src="favicon.ico"/></th>
                                <th className="c_recommendation_name">{this.state.name}</th>
                            </tr>
                        </tbody>
                    </table>
                    <hr/>
                    <div className="c_card_pointedprice">{this.state.pointedprice} <font size="3">{this.state.showinr?"INR":""}</font></div>
                    <div className="c_card_indicatedprice">{this.state.haschange?(() => {
                        return parseInt(this.state.indicatedprice) > 0? <font color="#4CAF50">{"+" + this.state.indicatedprice}</font>:<font color="#f44336">{this.state.indicatedprice}</font>
                    })():""}</div><br/>
                    {/* <div className="c_card_recommendationtext">Recommended by {this.state.recommendationcount} people</div> */}
                    <div className="c_card_detailarea">
                        {this.state.hasopenclose?<div className="">
                            <div className="c_card_openingclosingheader">Opened At</div>
                            <div className="c_card_openingclosingdetail">{this.state.openedat}</div>
                            <div className="c_card_openingclosingheader">Closed At</div>
                            <div className="c_card_openingclosingdetail">{this.state.closedat}</div>
                        </div>:""}
                    </div>
                    <h5><b><font color={this.state.frontdescriptionheadercolor}>{this.state.frontdescriptionheader}</font></b></h5>
                    {this.state.frontdescription}
                </div>
                <div className="c_card_back" onClick={this.flipThisCard.bind(this, false)} onMouseLeave={this.flipThisCard.bind(this, false)}>
                    <br/><p align="justify"><font color="#263238" size="2" family="arial">{this.state.backdescription}</font></p>
                    {/* <table>
                        <thead style={{color: "#2196F3"}}>
                            <tr>
                                <th>{this.state.symbol}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody style={{fontSize: "13px", color:"#607D8B"}}>
                            <tr>
                                <td>High:</td>
                                <td>{this.state.high}</td>
                            </tr>
                            <tr>
                                <td>Low:</td>
                                <td>{this.state.low}</td>
                            </tr>
                            <tr>
                                <td>Volume: {}</td>
                                <td>{this.state.volume}</td>
                            </tr>
                        </tbody>
                    </table> */}
                    {/* <font size={3} color="#2196F3">Why is this recommended?</font><br/> */}
                    {/* <p className="c_info_paragraph">{this.state.fullname} has Arth Score of {this.state.arthscore} Which is greater than {this.state.leadpercent} percent of the companies.</p> */}
                    {/* <p className="c_hoverable_text_green">See how Arth Score is calculated.</p> */}
                    {/* <font size={3} color="#263238">From </font><font size={3} color="#FF5722">{this.state.recommender}</font> */}
                </div>
            </ReactCardFlip>
            {/* 
             */}
        </div>
    }
}

export default RecommendationCloneCard